{
  "closing": "Clausura",
  "schedule-closing": "Agendar Clausura"
}